import {
  faChevronCircleUp,
  faChevronCircleDown,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toTitleCase } from "@src/utils";
import { useState } from "react";

function CompanionSessionTask({ task }) {
  const taskStatusMap = {
    SUCCEEDED: "green-500",
    FAILED: "red-500",
    PENDING: "orange-500",
    ACCEPTED: "green-600",
    REJECTED: "red-500",
    STARTED: "yellow-400",
  };
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className={`bg-${taskStatusMap[task.status]}
      bg-opacity-10
      text-${taskStatusMap[task.status]}
      text-black p-2 m-2 rounded-xl`}
    >
      <div
        className="flex items-center gap-2 text-md justify-between cursor-pointer"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        {isExpanded ? (
          <FontAwesomeIcon icon={faChevronCircleUp} />
        ) : (
          <FontAwesomeIcon icon={faChevronCircleDown} />
        )}
        <span className="flex-1">{task.name}</span>
        <span>({toTitleCase(task.status)})</span>
      </div>
      {isExpanded && (
        <div className="text-sm mt-1">{task.taskStepDescription}</div>
      )}
    </div>
  );
}

export function CompanionTasksSection({ tasks }) {
  if (!tasks?.length) {
    return null;
  }
  const sortedTasks = [...tasks].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
  );

  return sortedTasks.map((task) => (
    <CompanionSessionTask
      task={task}
      key={task.companionSessionTaskUuid}
    />
  ));
}
